<template>
  <div style="bg-im" >
  <landing :bg-color="FF165D"></landing>
  <section-2nd ></section-2nd>
  <section-3rd></section-3rd>
  <section-4th></section-4th>
  <section-5th class="im-form"></section-5th>
  <section-6th></section-6th>
  <section-7th></section-7th>
  <section-quote></section-quote>
  <section-8th></section-8th>
  <chaldalFaq></chaldalFaq>
  </div>
</template>
<script>
import Landing from '../components/im/LandingIm'
import Section2nd from '../components/im/Section2ndIm';
import Section3rd from '../components/im/Section3rdIm';
import Section4th  from '../components/im/Section4thIm';
import Section5th  from '../components/im/Section5thIm';
import Section6th from '../components/im/Section6thIm';
import Section7th from '../components/im/Section7thIm';
import Section8th from '../components/im/Section8thIm';
import chaldalFaq from '../components/faq/imFaq';
import SectionQuote from '../components/im/sectionQuote.vue';

export default {
  components: { Landing, Section2nd, Section3rd, Section4th, Section6th, Section7th, Section8th, Section5th,chaldalFaq,SectionQuote},

  created() { this.Loaded();
  }


}



</script>
<style scoped>
.bg-im{
  background-color: red !important;
}
.im-form {
  display: none;
}
</style>
